import React from 'react';
import PortfolioWebsite from './components/PortfolioWebsite';

function App() {
  return (
    <div className="App">
      <PortfolioWebsite />
    </div>
  );
}

export default App;